<div class="container" [ngClass.lt-md]="{'mobile': true}" [ngClass.md]="{'pad': true}">
<div class="menu">
  <span class="logo" (click)="dashboard()" style="cursor: pointer;">Kong Shing Travel LTD</span>
  <div class="button-container" fxShow fxHide.lt-md>
    <div *ngIf="loginService.isLoggedIn()" class="button" (click)="dashboard()">
      <mat-icon class="icon">home</mat-icon><span class="label" translate>MENU.DASHBOARD</span>
    </div>
    <div class="button" (click)="routeList()">
      <mat-icon class="icon">directions_bus_filled</mat-icon><span class="label" translate>MENU.ROUTE_LIST</span>
    </div>
    <!-- <div *ngIf="loginService.isLoggedIn() && notification_no" class="button" (click)="inbox()">
      <mat-icon class="icon">mail_outline</mat-icon><span class="label" translate [matBadge]="notification_no">MENU.INBOX</span>
    </div>
    <div *ngIf="loginService.isLoggedIn() && !notification_no" class="button" (click)="inbox()">
      <mat-icon class="icon">mail_outline</mat-icon><span class="label" translate>MENU.INBOX</span>
    </div> -->
    <div *ngIf="loginService.isLoggedIn()" class="button" (click)="profile()">
      <mat-icon class="icon">account_circle</mat-icon><span class="label" translate>MENU.PROFILE</span>
    </div>
    <div class="button" (click)="changeLanguage()">
      <mat-icon class="icon">language</mat-icon><span class="label MHeiHK" translate>MENU.CHANGE_LANGUAGE</span>
    </div>
    <div *ngIf="loginService.isLoggedIn()" class="button" (click)="logout()">
      <mat-icon class="icon">logout</mat-icon><span class="label" translate>MENU.LOGOUT</span>
    </div>
  </div>
  <button class="button-container"  mat-icon-button [matMenuTriggerFor]="menu" fxHide fxShow.lt-md>
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu style="float:right" #menu="matMenu" fxHide fxShow.lt-md>
    <button *ngIf="loginService.isLoggedIn()" mat-menu-item (click)="dashboard()">
      <mat-icon>home</mat-icon>
      <span translate>MENU.DASHBOARD</span>
    </button>
    <button *ngIf="loginService.isLoggedIn() && notification_no" (click)="inbox()" mat-menu-item>
        <mat-icon>mail_outline</mat-icon>
        <span translate [matBadge]="notification_no">MENU.INBOX</span>
    </button>
    <button *ngIf="loginService.isLoggedIn() && !notification_no" (click)="inbox()" mat-menu-item>
      <mat-icon>mail_outline</mat-icon>
      <span translate>MENU.INBOX</span>
    </button>
    <button (click)="routeList()" mat-menu-item>
        <mat-icon>directions_bus_filled</mat-icon>
        <span translate>MENU.ROUTE_LIST</span>
    </button>
    <button *ngIf="loginService.isLoggedIn()" (click)="profile()" mat-menu-item>
      <mat-icon>account_circle</mat-icon>
      <span translate>MENU.PROFILE</span>
    </button>
    <button (click)="changeLanguage()" mat-menu-item>
      <mat-icon>language</mat-icon>
      <span translate>MENU.CHANGE_LANGUAGE</span>
    </button>
    <button *ngIf="loginService.isLoggedIn()" (click)="logout()" mat-menu-item>
      <mat-icon>logout</mat-icon>
      <span translate>MENU.LOGOUT</span>
    </button>
  </mat-menu>
</div>
<div fxShow fxHide.lt-md style="font-size: 20px;
    color: white;
    background: red;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 15px;
    font-family: poppinsR;">
{{translate.currentLang=='en'?"Special notes for Sha Tin College students - QR code Boarding. Bus card will be replaced by a personal QR code system. Students with confirmed payment should download student QR code, save and scan while boarding.":"沙田學院學生特別提示 - 二維碼登車。巴士卡將由個人二維碼系統取代。已確認付款的學生請下載學生二維碼，保存後於登車時掃描。"}}
</div>
<div fxHide fxShow.lt-md style="font-size: 20px;
    color: white;
    background: red;
    padding-bottom: 10px;
    padding-left: 15px;
    font-family: poppinsR;
    padding-top: 77px;">
{{translate.currentLang=='en'?"Special notes for Sha Tin College students - QR code Boarding. Bus card will be replaced by a personal QR code system. Students with confirmed payment should download student QR code, save and scan while boarding.":"沙田學院學生特別提示 - 二維碼登車。巴士卡將由個人二維碼系統取代。已確認付款的學生請下載學生二維碼，保存後於登車時掃描。"}}
</div>

<!-- <nav>
  <ul>
    <li><a routerLink="/log-in" routerLinkActive="active">Log In</a></li>
  </ul>
</nav> -->
<div class="whiteboard">
<router-outlet></router-outlet>
</div>
</div>